import Script from 'next/script';

const script = `
;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
  p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
  };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
  n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//d3j1weegxvu8ns.cloudfront.net/2.11.0/t.js","snowplow"));
`;

export default function SnowPlow(): JSX.Element {
  return (
    <>
      <Script
        id="snowplow-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: script }}
      />
    </>
  );
}
